<template>
  <div class="form-dialog">
    <div class="form-body">
      <!-- algo mas? --->
      <div
        v-if="step == 0"
        class="anything-else"
      >
        <div class="form-title padding-title-score">
          {{ companyName !== 'simpli' ? 'Gracias por contactarnos' : '¿Hola? ¿Sigues ahí?' }}
        </div>
        <div class="form-box">
          <div class="score-subtitle">
            {{ companyName === 'nuam' ? '¿Necesitas que te ayude en algo más?' : companyName !== 'simpli'? '¿Necesitas algo más?': 'Si aún quieres conversar, continua en el chat.' }}
          </div>
        </div>
        <div
          style="padding: 5px"
          class="form-box-button-score"
        >
          <button
            :class="companyName === 'nuam' ? 'button-secondary' : companyName !== 'simpli' ? 'button-secondary' : 'button-primary'"
            @click="manejarSiClick"
          >
            {{ companyName === 'nuam' ? 'No' :companyName !== 'simpli' ? 'Sí' : 'Continuar' }}
          </button>
          <button
            :class="companyName === 'nuam' ? 'button-primary' :companyName !== 'simpli' ? 'button-primary' : 'button-secondary'"
            @click="manejarNoClick"
          >
            {{ companyName === 'nuam' ? 'Sí' : companyName !== 'simpli' ? 'No' : 'Salir' }}
          </button>
        </div>
        <!-- MSG -->
        <div class="padding-extra-btn" />
      </div>
      <!-- encuesta --->
      <div v-if="step == 1">
        <div class="form-body-scroll survey">
          <div class="form-title padding-title-score">
            {{ title }}
          </div>
          <div class="score-subtitle">
            ¿Cómo evalúas en general esta conversación?
          </div>
          <!--<div class="score-description" >Califica de 1 a 5, 5 es muy buena y 1 muy mala </div>-->
          <div class="score-image">
            <star-rating
              v-model="rating"
              :star-size="24"
              :show-rating="false"
              :border-width="2"
              :inactive-color="cssStyle.score.inactiveColor"
              :active-color="cssStyle.score.activeColor"
              :border-color="cssStyle.score.borderColor"
            />
          </div>
          <div class="score-subtitle">
            <hr>
            ¿Pudiste resolver tu inquietud en esta conversación?
          </div>
          <div class="score-options">
            <button
              class="form-button-option"
              :class="{
                'form-button-option-selected': buttonOptionSi === true,
              }"
              @click="setOption(true)"
            >
              Sí
            </button>
            <button
              class="form-button-option"
              :class="{
                'form-button-option-selected': buttonOptionSi === false,
              }"
              @click="setOption(false)"
            >
              No
            </button>
          </div>
          <div v-if="1 == 1 || (rating > 0 && rating <= 2)">
            <div
              class="score-subtitle"
              style="margin-bottom: 5px"
            >
              Cuéntame ¿Qué mejorarías?
            </div>
            <div
              class="score-comments"
            >
              <textarea
                v-model="commentsValue"
                :class="{ 'score-comments-textarea--filled': commentsValue }"
              />
            </div>
          </div>
          <div
            v-else
            style="height: 20px"
          />
          <div class="form-box-button">
            <button
              class="button-secondary"
              @click="omitirClick"
            >
              {{ companyName !== 'simpli' ? 'Omitir' : 'Cerrar' }}
            </button>
            <button
              class="button-primary"
              @click="valorarClick"
            >
              {{ companyName !== 'simpli' ? 'Valorar' : 'Evaluar' }}
            </button>
          </div>
        </div>

        <!-- MSG -->
        <div class="form-error">
          {{ errormsg }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from './main'
import StarRating from 'vue-star-rating'

export default {
  components: {
    StarRating
  },
  props: {
    cssStyle: {
      type: Object
    },
    companyName: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      title: '',
      step: 0,
      buttonOptionSi: null,
      rating: 0,
      commentsValue: '',
      errormsg: ''
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'Score') return
      if (e.evento === 'newdata') {
        this.step = e.dato.step
        this.title = e.dato.title ? e.dato.title : 'Evalúa mi atención'
      }
    })
  },
  methods: {
    manejarSiClick () {
      if (this.companyName === 'nuam') {
        this.algoMasNoClick()
      } else {
        this.algoMasSiClick()
      }
    },
    manejarNoClick () {
      if (this.companyName === 'nuam') {
        this.algoMasSiClick()
      } else {
        this.algoMasNoClick()
      }
    },
    algoMasSiClick () {
      serverUI.$emit('FormEvent', {
        form: 'Score',
        evento: 'algoMasSiClick'
      })
    },
    algoMasNoClick () {
      serverUI.$emit('FormEvent', {
        form: 'Score',
        evento: 'algoMasNoClick'
      })
      serverUI.$emit('setLastUserText', '')
    },
    setOption (option) {
      this.buttonOptionSi = option
    },
    omitirClick () {
      this.step = '1'
      serverUI.$emit('FormEvent', {
        form: 'Score',
        evento: 'omitirClick',
        rating: 0,
        option: 'omitida',
        comments: ''
      })
    },
    valorarClick () {
      const rating = Number(this.rating)
      this.errormsg = ''
      if (rating === 0) {
        this.errormsg = 'Falta indicar tu calificación'
        return
      }
      if (this.buttonOptionSi === null) {
        this.errormsg = 'Falta indicar si pudiste atender tu inquietud'
        return
      }

      serverUI.$emit('FormEvent', {
        form: 'Score',
        evento: 'valorarClick',
        rating: this.rating,
        option: this.buttonOptionSi ? 'inquietud_ok' : 'inquietud_nok',
        comments: this.commentsValue
      })
    }
  }
}
</script>
<style lang="css" scoped>
.score-title {
    margin: 5px 0 5px 0;
    font-size: 16px;
    text-align: center;
    color: #326295;
    font-weight: 950;
}

.score-subtitle {
    margin: 10px 5px 7px 0;
    font-size: 15px;
    text-align: center;
    color: #326295;
}

.score-options {
    text-align: center;
    min-height: 36px;
    padding: 15px 0 10px 0;
}

.score-description {
    margin-top: 10px;
    font-size: 12px;
    text-align: center;
    color: grey;
}

.score-image {
    margin-top: 10px;
    margin-left: 22%;
}

.score-comments {
    display: flex;
    justify-content: center;
    align-items: center;
}

.score-comments textarea {
    width: 85%;
    height: 50px;
    resize: none;
    margin-top: -3px;
    padding: 0 3px;
    font-size: 13px;
}

.anything-else {
  height: 160px;
}
.survey {
  margin: 80px 20px 20px !important;
}
.padding-title-score {
    padding: 5% 0 5% 0 !important;
    margin: 0 !important;
    text-align: center !important;
    border-bottom: 1.5px solid #d8d9da !important;
}
.form-box-button-score {
    padding-top: 10px 0;
    text-align: right;
    min-height: 41px;
    width: 250px;
    display: flex;
    justify-content: space-between;
    margin-left: 30px;
}
</style>
